import { Skeleton } from '@mui/material';

interface Props {
  numberOfCards?: number;
}

const PostSkeleton = () => (
  <div className="w-full md:min-w-[240px] md:w-1/5 lg:w-1/6">
    <div className="border rounded-lg m-2">
      <div className="flex p-2 m-1">
        <div className="mr-2">
          <Skeleton variant="circular" width={24} height={24} />
        </div>
        <div className="w-full"><Skeleton variant="text" /></div>
      </div>
      <div className="mb-8">
        <Skeleton variant="rectangular" width="100%" height={200} />
      </div>
      <div />
    </div>
  </div>
);

export const PostListSkeleton = ({
  numberOfCards = 5,
}: Props) => (
  <div className="w-full flex justify-between flex-wrap">
    {Array.from(Array(numberOfCards),
      (_, i) => <PostSkeleton key={i} />)}
  </div>
);
